import type { AppointmentListItem } from "../../../shared/api-types";
import type { RdScheduleMirrorState } from "../../../shared/rd-schedule-actions";

// NO-917. Where a saved visit's copy in Healthie stands, as the RD reads it.
// A leaf module so the marks, the polling and the tests share one set of words.

/** How often an open tab reads again while a visit still waits for its copy. */
export const MIRROR_POLL_MS = 10_000;

export const MIRROR_PENDING_TEXT = "Not in Healthie yet";
export const MIRROR_PENDING_HINT = "Saved in NDD. The copy in Healthie is on its way.";
export const MIRROR_FAILED_TEXT = "Couldn't copy to Healthie";
export const MIRROR_FAILED_HINT =
  "Saved in NDD, but the copy in Healthie did not go through. Retry to send it again.";

interface MirrorCarrier {
  mirrorState?: RdScheduleMirrorState | null;
}

export function hasPendingMirror(items: readonly MirrorCarrier[] | undefined): boolean {
  return items?.some((item) => item.mirrorState === "pending") ?? false;
}

interface ListBody {
  data: { status: string; appointments?: AppointmentListItem[] };
}

/** The Week answer: read again while any visit is waiting for its copy. */
export function weekMirrorPoll(
  body:
    | { data: { status: string; appointments?: readonly MirrorCarrier[] } }
    | undefined
): number | false {
  const data = body?.data;

  return data?.status === "ok" && hasPendingMirror(data.appointments)
    ? MIRROR_POLL_MS
    : false;
}

/** The Past week answer. */
export function listMirrorPoll(body: ListBody | undefined): number | false {
  return body?.data.status === "available" && hasPendingMirror(body.data.appointments)
    ? MIRROR_POLL_MS
    : false;
}

/** The Upcoming list: pages of the same list answer. */
export function pagesMirrorPoll(
  pages: readonly ListBody[] | undefined
): number | false {
  return pages?.some((page) => listMirrorPoll(page) !== false) ? MIRROR_POLL_MS : false;
}
